import { tz } from "@date-fns/tz";
import { Grid2 } from "@mui/material";
import { startOfDay } from "date-fns";
import { useIntl } from "react-intl";

import { GetForecastResponsePrepared, useGetEarnings } from "api";
import { Widget, WidgetContent } from "components/elements/mui";
import { formatPln } from "components/elements/widgets/Earnings/format";
import { useFormatMessage } from "lang";
import { getSelectedPowerPlant, useAppSelector } from "store";
import { formatEnergy } from "utils/energy";

export const ForecastEnergy = ({
  data,
  isLoading,
}: {
  data?: GetForecastResponsePrepared;
  isLoading?: boolean;
}) => {
  const formatMessage = useFormatMessage();
  const intl = useIntl();
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  // Today's expected earnings under this forecast — earned so far plus the
  // forecast remainder — shown beside the energy for plants selling via Tradea.
  const { data: earnings } = useGetEarnings();
  const expectedPln = earnings?.configured
    ? (earnings.projectedOursPln ?? earnings.totals.expectedOursPln)
    : null;
  // Two tiles as soon as we know the plant sells via Tradea (or while that is
  // still being checked), so the layout doesn't jump when the figure arrives.
  const showEarnings = earnings === undefined || earnings.configured;

  const energy = formatEnergy(
    data?.daily.find(
      (d) =>
        d.date.getTime() ===
        startOfDay(new Date(), {
          in: tz(selectedPowerPlant?.timezone || "Europe/Warsaw"),
        }).getTime(),
    )?.energy || 0,
  );

  return (
    <Widget
      title={formatMessage("predictedProduction")}
      loading={isLoading}
      size={{
        xs: 6,
      }}
      content={
        !showEarnings ? (
          <WidgetContent value={energy.value} unit={energy.unit} />
        ) : (
          <Grid2 container size={12} justifyContent="space-between">
            <WidgetContent
              value={energy.value}
              unit={energy.unit}
              gridProps={{ alignItems: "flex-start", size: { xs: 6 } }}
            />
            <WidgetContent
              value={expectedPln === null ? "—" : formatPln(intl, expectedPln)}
              unit="PLN"
              gridProps={{ size: { xs: 6 } }}
            />
          </Grid2>
        )
      }
    />
  );
};
